import { getAuthToken } from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const rentPaymentsService = {
  // Get rent payments edit data
  // Laravel Parity: Route is /rents/{room}/payments/edit
  async getRentPaymentsEditData(roomId) {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/api/rents/${roomId}/payments/edit`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch rent payments data');
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching rent payments data:', error);
      // Return mock data as fallback
      return getMockRentPaymentsData(roomId);
    }
  },

  // Update rent payments
  // Laravel Parity: Route is POST /rents/{room}/payments/edit
  async updateRentPayments(roomId, paymentsData) {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/api/rents/${roomId}/payments/edit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          payments: paymentsData
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update rent payments');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating rent payments:', error);
      throw error;
    }
  }
};

// Mock data for fallback
function getMockRentPaymentsData(roomId) {
  const mockRoom = {
    id: parseInt(roomId),
    name: "Room 1",
    price: 200,
    hasCouple: () => true
  };

  const mockProperty = {
    id: 1,
    property_id: "PROP001",
    name: "25 Bowie Close",
    status_text: "Active",
    address_1: "25 Bowie Close, London",
    postcode: "SW1A 1AA",
    date_taken_on: "2024-01-01",
    date_taken_back: "2025-01-01",
    short_description: "Modern property with excellent facilities"
  };

  const mockRents = [
    {
      id: 1,
      guardian: {
        id: 1,
        unique_guardian_number: "UGD001",
        full_name: "John Smith",
        status: {
          id: 19,
          name: "Placed"
        }
      },
      room: {
        id: 1,
        price: 200
      },
      license_fee: 200,
      damage_security_payment: 200,
      pay_gas: 1,
      pay_electric: 1,
      pay_water: 0,
      pay_council_tax: 0
    },
    {
      id: 2,
      guardian: {
        id: 2,
        unique_guardian_number: "UGD002",
        full_name: "Jane Doe",
        status: {
          id: 19,
          name: "Placed"
        }
      },
      room: {
        id: 1,
        price: 200
      },
      license_fee: 200,
      damage_security_payment: 200,
      pay_gas: 1,
      pay_electric: 1,
      pay_water: 1,
      pay_council_tax: 0
    }
  ];

  return {
    room: mockRoom,
    property: mockProperty,
    rents: mockRents,
    disabledRents: [],
    fieldsWithOld: true,
    action: "Change Rent",
    url: "rents.payments.update",
    moveGuardian: false
  };
} 